<template>
  <el-row  :gutter="20">
    <el-col :xs="24" :sm="5">
      <el-form :model="importForm" ref="importForm" :rules="rules">
        <el-form-item prop="brandName" label="Brand">
          <el-input v-model="importForm.brandName" placeholder="Brand"></el-input>
        </el-form-item>
        <el-form-item prop="billNo" label="Bill No.">
          <el-input v-model="importForm.billNo" placeholder="Bill No." :disabled="this.submitType === 2" type="number"></el-input>
        </el-form-item>
        <el-form-item prop="billDate" label="Bill Date">
          <el-date-picker
          v-model="importForm.billDate"
          format="MM/dd/yyyy"
          value-format="MM/dd/yyyy"
          type="date"
          placeholder="Bill Date"
          style="width:100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="terms" label="Terms">
          <el-input v-model="importForm.terms" placeholder="Terms"></el-input>
        </el-form-item>
        <el-form-item prop="category" label="Category">
          <el-input v-model="importForm.category" placeholder="Category"></el-input>
        </el-form-item>
        <el-form-item prop="description" label="Description">
          <el-input v-model="importForm.description" placeholder="Description"></el-input>
        </el-form-item>
        <el-form-item prop="amount" label="Amount">
          <el-input type="number" v-model="importForm.amount" placeholder="Amount"></el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="danger" plain @click="clearFields">Reset</el-button>
          <el-button type="primary" style="float: right;" @click="handleAddBill">{{ submitType === 1 ? 'Add' : 'Update' }}</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col :xs="24" :sm="19">
      <div style="float: right; margin-bottom: 5px">
        <el-button type="primary" icon="el-icon-upload" :loading="loading" :disabled="loading" @click="handleImport">Import</el-button>
        <el-button type="danger" icon="el-icon-remove" plain @click="clearTable"> Clear</el-button>
      </div>
      
      <e-table :headers="headers" :data="items" :total="items.length" :height="window.height - 180">
        <template #actions="{ scope }">
					<el-button v-tooltip.top="'Update'" size="mini" type="warning" icon="el-icon-edit" @click="handleUpdate(scope.row)"></el-button>
          <el-button v-tooltip.top="'Delete'" size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)"></el-button>
				</template>
      </e-table>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    importForm: {
      brandName: '',
      billNo: '',
      billDate: '',
      terms:'',
      category: '',
      description: '',
      amount: 0
    },
    rules: {
      brandName: [
        { required: true, message: 'Please input brand.', trigger: 'blur' }
      ],
      billNo: [
        { required: true, message: 'Please input bill no.', trigger: 'blur' },
      ],
      billDate: [
        { required: true, message: 'Please input bill date.', trigger: 'blur' }
      ],
      terms: [
        { required: true, message: 'Please input terms.', trigger: 'blur' }
      ],
      category: [
        { required: true, message: 'Please input category.', trigger: 'blur' }
      ],
      description: [
        { required: true, message: 'Please input description.', trigger: 'blur' }
      ],
      amount: [
        { required: true, message: 'Please input amount.', trigger: 'blur' }
      ]
    },
    headers: [
      { text: 'Brand', value: 'brandName', sortable: true },
      { text: 'Bill No.', value: 'billNo', sortable: true },
      { text: 'Bill Date', value: 'billDate', sortable: true },
      { text: 'Terms', value: 'terms', sortable: true },
      { text: 'Category', value: 'category', sortable: true },
      { text: 'Description', value: 'description', sortable: true },
      { text: 'Amount', value: 'amount', sortable: true },
      { text: 'Actions', align: 'center', width: '120'},
    ],
    items: localStorage.getItem('importForm') ? JSON.parse(localStorage.getItem('importForm')) : [],
    submitType: 1
  }),
  methods: {
    handleAddBill(){
      this.$refs['importForm'].validate(valid => {
        if(valid){
          let prevItems = localStorage.getItem('importForm') ? JSON.parse(localStorage.getItem('importForm')) : [];

          let checkBill = prevItems.filter(e => e.billNo === this.importForm.billNo);
          if(checkBill.length > 0 && this.submitType === 1){
            this.$message({ type: 'error', message: 'Bill No exist!' });
            return;
          }

          if(this.submitType === 1){
            let newImportForm = {
              ...this.importForm,
              amount: parseInt(this.importForm.amount).toFixed(2)
            }

            prevItems.push(newImportForm);
            this.items.push(newImportForm);
            localStorage.setItem('importForm', JSON.stringify(prevItems));
          }else{
            let updatedData = [];
            for(let x in prevItems){
              let data = prevItems[x];
              if(data.billNo === this.importForm.billNo){
                data = {
                  ...this.importForm,
                  amount: parseInt(this.importForm.amount).toFixed(2)
                }
              }
              updatedData.push(data)
            }
            localStorage.setItem('importForm', JSON.stringify(updatedData));
          }
          this.clearFields();
        }
      })
    },
    handleDelete(row){
      let currentItems = JSON.parse(localStorage.getItem('importForm'));
      let updatedItems = currentItems.filter(item => item.billNo !== row.billNo)
      this.items = updatedItems;
      localStorage.setItem('importForm', JSON.stringify(updatedItems));
    },
    handleUpdate(row){
      this.importForm = row;
      this.submitType = 2;
    },
    clearTable(){
      this.items = [];
      localStorage.setItem('importForm', JSON.stringify([]));
      this.clearFields()
    },
    clearFields(){
      this.importForm = {
        brandName: '',
        terms:'',
        category: '',
        description: '',
        amount: 0,
        billNo: '',
        billDate: ''
      }
      this.submitType = 1;
    },
    async handleImport(){
      if(this.items.length > 0){
        this.loading = true;
        let reqBody = {
          user_id: JSON.parse(localStorage.getItem('user')).employee_id,
          data: this.items
        }
        
        try {
          // $http baseURL already includes /api; keep relative path
          let response = await this.$http.post('/extensiv/createBill', JSON.stringify(reqBody))
          if(response.status === 200){
            this.$message({
                type: 'success',
                message: response.data.msg
            })
          }
        } catch (error) {
          this.$message({
            type: 'error',
            message: error.data.err.msg
          })
        }finally{
          this.loading = false;
        }
      }else{
        this.$message({
            type: 'error',
            message: 'No data to import! Kindly Add.'
        })
      }
    }
  }
}
</script>